import requestService from './requestService';
import { showSuccess, showError } from './toastService';
import i18n from '../i18n';
import { getTranslationOrderLevelId } from '../utils/translationLevels';

const endpoints = {
  createTranslationOrder: '/prebooking/create',
  cancelTranslationOrder: '/prebooking/cancel/',
};

export const createTranslationOrder = async (orderData) => {
  const body = {
    type: 'translation',
    contractId: orderData.contractId || null,
    languageId: orderData.fromLanguageId || null,
    targetLanguageId: orderData.toLanguageId || null,
    comments: orderData.instructionsForTranslator || null,
    date: orderData.desiredDeliveryDate || null,
    duration: 3600, // Backend requires non-zero duration even for translations
    presence: 'remote',
    invoiceUserGroupId: orderData.invoiceUserGroupId || null,
    invoiceRef: orderData.additionalInvoicingInfo || null,
    externalOrder: orderData.externalOrderId || null,
    ccEmails: orderData.ccEmails?.join(',') || null,
    // Required translator authorization: exactly one selected level is a
    // requirement; all levels selected means none (null, dropped below).
    levelId: getTranslationOrderLevelId(orderData.translatorLevelIds),
  };

  // Remove null/undefined fields (same pattern as prebookService.js getPrebookBody)
  const cleanBody = Object.keys(body).reduce((memo, field) => {
    if (body[field] || body[field] === false || body[field] === 0) {
      memo[field] = body[field];
    }
    return memo;
  }, {});

  try {
    const result = await requestService.postWithJson(
      endpoints.createTranslationOrder,
      null,
      cleanBody,
      { apiType: 'platform-v2' }
    );

    if (result.error) {
      throw new Error(result.message);
    }

    // The wizard announces success itself once the attachments have been uploaded
    // too (TUL-5763); a toast here would fire before a single byte has been sent.
    return result;
  } catch (e) {
    console.error('Failed to create translation order:', e);
    showError(i18n('translation_order_submit_failed'));
    throw e;
  }
};

export const cancelTranslationOrder = async (orderId) => {
  if (!orderId) throw new Error('Order ID is required');
  try {
    const params = requestService.getDefaultParams();
    const result = await requestService.putWithJson(
      `${endpoints.cancelTranslationOrder}${encodeURIComponent(orderId)}`,
      params,
      { reason: '', userType: 'Customer' },
      { apiType: 'platform-v2' }
    );

    if (result.error) {
      throw new Error(result.message);
    }

    showSuccess(i18n('translation_order_cancelled_successfully'));
    return result;
  } catch (e) {
    console.error('Failed to cancel translation order:', e);
    showError(i18n('translation_order_cancel_failed'));
    throw e;
  }
};
